import { FlowbiteCardTheme } from 'flowbite-react';

export const cardTheme: FlowbiteCardTheme = {
    root: {
        base: 'flex rounded-2xl bg-system-surface-container text-system-primary',
        children: 'flex h-full flex-col justify-center p-4',
        horizontal: {
            off: 'flex-col',
            on: 'flex-col md:max-w-xl md:flex-row',
        },
        href: 'hover:bg-gray-100 dark:hover:bg-gray-700',
    },
    img: {
        base: 'bg-system-surface-container text-system-primary',
        horizontal: {
            off: 'rounded-t-2xl',
            on: 'h-96 rounded-t-2xl object-cover md:h-auto md:w-48 md:rounded-none md:rounded-l-2xl',
        },
    },
};
